var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('link-button',{staticClass:"ma-2",staticStyle:{"border-radius":"16px","min-width":"32px","height":"32px"},attrs:{"to":_vm.route,"color":_vm.color}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }